// @ts-ignore
import VueFinder from 'vuefinder/dist/vuefinder'
// @ts-ignore
import en from 'vuefinder/dist/locales/en.js'
// @ts-ignore
import tr from 'vuefinder/dist/locales/tr.js'
// @ts-ignore
import ru from 'vuefinder/dist/locales/ru.js'

import pt_BR from '@modules/Drive/components/pt-BR.js'
import es_ES from '@modules/Drive/components/es.js'
import type { GlobalContext } from '@src/types/GlobalContext'

export default (cntx: GlobalContext) => {
    cntx.app.use(VueFinder, {
        i18n: {
            en,
            pt_BR,
            es_ES,
        },
    })
}
